import React, { useState } from "react";
import CardContenido from "./CardContenido";
import arrow_up from "../../../../assets/vw/svg/arrow-up.svg";
import arrow_down from "../../../../assets/vw/svg/arrow-down.svg";


const SelectCard = ({
    infoCard,
    editar = () => { },
    handleArchivar = () => { },
    rowDesarchivar = () => { },
    index,
    selectCheck,
    archivo = false,
    notificaciones,
    currentActive,
    setCurrentActive
}) => {

    const [showContent, setShowContent] = useState(false);

    const getNotificacion = (idNotificacion) => {
        const objApp = notificaciones.find(
            (item) => item.idNotificacion === idNotificacion
        );
        return objApp.accion;
    };

    return (
        <div className={"select-card-container"}>
            <div className={"select-card-header d-flex justify-content-between"}>
                <div className={"d-flex"}>
                    <div className="ms-auto align-self-center">
                        <input
                            type="checkbox"
                            className="checkbox-round"
                            id={"select-" + index}
                            value={infoCard.original.idDestinatario_2}
                            onChange={(e) => selectCheck(e, index)}
                        />
                    </div>
                    <div className="container_id bold ml-3 mr-1 font-weight-bolder">
                        {infoCard.original.idDestinatario_2}
                    </div>
                    <div className="select-card-title-one-word font-weight-bolder">
                        {getNotificacion(infoCard.original.idNotificacion_2)}
                    </div>
                </div>
                <div>
                    <button
                        className={"button_icon-vw select-card-arrow"}
                        onClick={() => {
                            setShowContent(prevState => !prevState);
                            setCurrentActive({ id: index });
                        }}
                    >
                        {
                            (showContent && (currentActive.id !== null && (currentActive.id === index))) ? (
                                <img
                                    src={arrow_up}
                                    alt="arrow-up"
                                />
                            ) : (
                                <img
                                    src={arrow_down}
                                    alt="arrow-down"
                                />
                            )
                        }
                    </button>
                </div>

            </div>
            {
                (showContent && (currentActive.id !== null && (currentActive.id === index))) && (
                    <CardContenido
                        infoCard={infoCard}
                        handleArchivar={handleArchivar}
                        editar={editar}
                        archivo={archivo}
                        rowDesarchivar={rowDesarchivar}
                        id={index}
                        setShowContent={setShowContent}
                    />
                )
            }
        </div>
    );
}

export default SelectCard;